// actionTypes.js
export const SET_VALUE_TYPES_PUBLIPOSTAGES = "SET_VALUE_TYPES_PUBLIPOSTAGES";
export const SET_CATEGORIE_TYPES_PUBLIPOSTAGES = "SET_CATEGORIE_TYPES_PUBLIPOSTAGES";
export const SET_CURRENT_PAGE_TYPES_PUBLIPOSTAGES = "SET_CURRENT_PAGE_TYPES_PUBLIPOSTAGES";
export const SET_ORDER_TYPES_PUBLIPOSTAGES = "SET_ORDER_TYPES_PUBLIPOSTAGES";
export const SET_SORT_FIELD_TYPES_PUBLIPOSTAGES = "SET_SORT_FIELD_TYPES_PUBLIPOSTAGES";
export const SET_ACCES_INVESTISSEUR_TYPES_PUBLIPOSTAGES = "SET_ACCES_INVESTISSEUR_TYPES_PUBLIPOSTAGES";
export const SET_ACCES_CGP_TYPES_PUBLIPOSTAGES = "SET_ACCES_CGP_TYPES_PUBLIPOSTAGES";
